import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { TrendingUp, Home, Printer } from "lucide-react";

export default function Appendix() {



  const handlePrint = () => {
    window.print();
  };





  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-white">
      {/* Header */}
      <div className="bg-white shadow-sm border-b">
        <div className="max-w-6xl mx-auto px-6 py-4 flex justify-between items-center">
          <div className="flex items-center space-x-4">
            <div className="w-20 h-12 bg-white rounded-lg flex items-center justify-center p-1">
              <img src="./images/dnuvo.png" alt="d.nuvo Logo" className="w-full h-full object-contain" />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-gray-900">Brand Guide Appendix</h1>
              <p className="text-sm text-gray-600">Content Creation Toolkit • Messaging & Assets</p>
            </div>
          </div>
          <div className="flex items-center space-x-3">
            <a href="#/" className="inline-flex items-center space-x-2">
              <Button className="flex items-center space-x-2 bg-blue-600 hover:bg-blue-700 text-white">
                <Home className="w-4 h-4" />
                <span>Back to Main Kit</span>
              </Button>
            </a>
            
            <Button onClick={handlePrint} className="flex items-center space-x-2 bg-green-600 hover:bg-green-700">
              <Printer className="w-4 h-4" />
              <span>Print</span>
            </Button>

          </div>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-6 py-8 space-y-8 print:space-y-0">
        
        {/* Brand Guide Appendix */}
        <div className="print-card">
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center space-x-2">
              <TrendingUp className="w-6 h-6 text-blue-600" />
              <span>Brand Guide for Content Creation</span>
            </CardTitle>
            <p className="text-sm text-muted-foreground mt-2">Key messaging, story angles, and assets for compelling d.nuvo® content</p>
          </CardHeader>
          <CardContent>
            <div className="space-y-8">
              
              {/* Section I: Key Messaging */}
              <div>
                <h3 className="text-2xl font-bold text-blue-800 mb-4">I. Key Messaging & Talking Points</h3>
                <div className="space-y-4">
                  <div className="bg-blue-50 p-4 rounded-lg border-l-4 border-blue-400">
                    <h4 className="font-bold text-blue-800 mb-2">🔍 The "Difference of Depth"</h4>
                    <p className="text-gray-700 text-sm">This isn't just surface-level skincare. d.nuvo's core mission is to solve the problem of absorption, delivering active ingredients up to 15x deeper into the skin where real, visible change happens.</p>
                  </div>
                  
                  <div className="bg-green-50 p-4 rounded-lg border-l-4 border-green-400">
                    <h4 className="font-bold text-green-800 mb-2">🔬 Patented Technology You Can Feel</h4>
                    <p className="text-gray-700 text-sm">Talk about the Ceramided™ technology—a world-first that uses the skin's own building blocks (Ceramide NP) to deliver actives while simultaneously repairing and strengthening the barrier.</p>
                  </div>
                  
                  <div className="bg-purple-50 p-4 rounded-lg border-l-4 border-purple-400">
                    <h4 className="font-bold text-purple-800 mb-2">🧪 Science, Not Trends</h4>
                    <p className="text-gray-700 text-sm">d.nuvo was born from decades of R&D to solve a fundamental problem (absorption and stability), not just to follow a fleeting ingredient trend.</p>
                  </div>
                  
                  <div className="bg-pink-50 p-4 rounded-lg border-l-4 border-pink-400">
                    <h4 className="font-bold text-pink-800 mb-2">🌸 Gentle but Powerful Solutions</h4>
                    <p className="text-gray-700 text-sm">Highlight how products like the Calming Ampoule use a patented herbal complex (ACZERO®) and Bakuchiol to achieve clinical results without the harshness of traditional acids.</p>
                  </div>
                  
                  <div className="bg-yellow-50 p-4 rounded-lg border-l-4 border-yellow-400">
                    <h4 className="font-bold text-yellow-800 mb-2">💰 Luxury Science, Accessible Price</h4>
                    <p className="text-gray-700 text-sm">d.nuvo offers the rigor and efficacy of high end clinical brands at an accessible "masstige" price point.</p>
                  </div>
                  
                  <div className="bg-orange-50 p-4 rounded-lg border-l-4 border-orange-400">
                    <h4 className="font-bold text-orange-800 mb-2">🌴 Climate-Adapted for SEA</h4>
                    <p className="text-gray-700 text-sm">The lightweight, breathable, and non-comedogenic formulations are explicitly designed to be comfortable and effective in hot and humid Southeast Asian climates.</p>
                  </div>
                </div>
              </div>
              
              {/* Section II: Story Angles */}
              <div>
                <h3 className="text-2xl font-bold text-green-800 mb-4">II. Story & Content Angles</h3>
                <div className="grid md:grid-cols-2 gap-4">
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h4 className="font-semibold text-gray-800 mb-2">📦 The Unboxing & Texture Test</h4>
                    <p className="text-sm text-gray-600">Showcase the minimalist, science-forward packaging. Emphasize the non-sticky, fast-absorbing quality.</p>
                  </div>
                  
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h4 className="font-semibold text-gray-800 mb-2">✨ The 3-Day Radiance Challenge</h4>
                    <p className="text-sm text-gray-600">Use the Fresh Ceramided™ Vitamin C Ampoule and document the clinically confirmed visible brightening results in just 3 days.</p>
                  </div>
                  
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h4 className="font-semibold text-gray-800 mb-2">🔬 Science Deep Dive</h4>
                    <p className="text-sm text-gray-600">Use visuals to explain the difference between d.nuvo's Ceramided™ technology and traditional, unstable liposomes.</p>
                  </div>
                  
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h4 className="font-semibold text-gray-800 mb-2">🌿 Soothing Sensitive Skin</h4>
                    <p className="text-sm text-gray-600">Review the Trouble Calming Ampoule as a powerful, non-irritating alternative to harsh acid treatments for acne-prone skin.</p>
                  </div>
                  
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h4 className="font-semibold text-gray-800 mb-2">☀️ The Ultimate Sun Protection</h4>
                    <p className="text-sm text-gray-600">Feature the Dual C Sun Serum and its "dual defense" mechanism: UV protection plus Vitamin C antioxidant power.</p>
                  </div>
                  
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h4 className="font-semibold text-gray-800 mb-2">🔍 The Transparency Promise</h4>
                    <p className="text-sm text-gray-600">Discuss the brand's commitment to no artificial colorants with the Vitamin C Ampoule.</p>
                  </div>
                </div>
              </div>
              
              {/* Section III: Hashtags & Handles */}
              <div>
                <h3 className="text-2xl font-bold text-red-800 mb-4">III. Mandatory Hashtags & Handles</h3>
                <div className="space-y-4">
                  <div className="bg-red-50 p-4 rounded-lg">
                    <h4 className="font-semibold text-red-800 mb-2">📱 High-Reach / Core Brand</h4>
                    <div className="flex flex-wrap gap-2">
                      <Badge className="bg-red-100 text-red-800">#dnuvo</Badge>
                      <Badge className="bg-red-100 text-red-800">#dnuvosg</Badge>
                      <Badge className="bg-red-100 text-red-800">#skincarescience</Badge>
                      <Badge className="bg-red-100 text-red-800">#DeepEfficacy</Badge>
                    </div>
                  </div>
                  
                  <div className="bg-blue-50 p-4 rounded-lg">
                    <h4 className="font-semibold text-blue-800 mb-2">🎯 Niche / Benefit-Focused</h4>
                    <div className="flex flex-wrap gap-2">
                      <Badge className="bg-blue-100 text-blue-800">#VitaminCserum</Badge>
                      <Badge className="bg-blue-100 text-blue-800">#Bakuchiol</Badge>
                      <Badge className="bg-blue-100 text-blue-800">#SkinBarrierRepair</Badge>
                      <Badge className="bg-blue-100 text-blue-800">#GlassSkin</Badge>
                    </div>
                  </div>
                  
                  <div className="bg-green-50 p-4 rounded-lg">
                    <h4 className="font-semibold text-green-800 mb-2">🔥 Trending / Lifestyle / Engagement</h4>
                    <div className="flex flex-wrap gap-2">
                      <Badge className="bg-green-100 text-green-800">#sgbeauty</Badge>
                      <Badge className="bg-green-100 text-green-800">#skintok</Badge>
                      <Badge className="bg-green-100 text-green-800">#skincarejunkie</Badge>
                      <Badge className="bg-green-100 text-green-800">#ScienceofAbsorption</Badge>
                      <Badge className="bg-green-100 text-green-800">#AcneCare</Badge>
                      <Badge className="bg-green-100 text-green-800">#Ceramided</Badge>
                      <Badge className="bg-green-100 text-green-800">#AntiPigmentation</Badge>
                      <Badge className="bg-green-100 text-green-800">#kbeauty</Badge>
                      <Badge className="bg-green-100 text-green-800">#dermaskincare</Badge>
                      <Badge className="bg-green-100 text-green-800">#newlaunch</Badge>
                    </div>
                  </div>
                  
                  <div className="bg-purple-50 p-4 rounded-lg">
                    <h4 className="font-semibold text-purple-800 mb-2">🔗 Brand Social Media Hub</h4>
                    <div className="text-center">
                      <div className="bg-white p-4 rounded-lg border-2 border-purple-300 mb-3">
                        <h5 className="font-bold text-purple-800 mb-2">🌐 All Social Platforms in One Place</h5>
                        <a href="https://www.linktr.ee/d.nuvo" target="_blank" rel="noopener noreferrer" 
                           className="inline-flex items-center space-x-2 bg-purple-600 hover:bg-purple-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors">
                          <span>🔗 Visit d.nuvo Linktree</span>
                        </a>
                      </div>
                      <p className="text-sm text-purple-700">
                        <strong>Direct Access:</strong> <a href="https://www.linktr.ee/d.nuvo" target="_blank" rel="noopener noreferrer" className="text-purple-600 underline font-mono">https://www.linktr.ee/d.nuvo</a>
                      </p>
                      <p className="text-xs text-purple-600 mt-2">
                        Find all d.nuvo® social media platforms, website, and shopping links in one convenient location
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              
            </div>
          </CardContent>
        </Card>
        </div>
      </div>

      {/* Footer */}
      <div className="bg-gray-900 text-white py-6">
        <div className="max-w-6xl mx-auto px-6 text-center">
          <p className="text-sm text-gray-400">© 2025 d.nuvo® by Etheria Skincare Pte Ltd. All rights reserved.</p>
          <p className="text-xs text-gray-500 mt-2">This brand guide contains confidential brand information. Please use responsibly.</p>
        </div>
      </div>
    </div>
  );
}